module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section",
    attrs: {
      "id": "schools"
    }
  }, [_c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('temporal-notification', {
    attrs: {
      "type": "success",
      "show": _vm.showSuccess
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v("New school")]), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "field control"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  })]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })]), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canCreate
    },
    on: {
      "click": _vm.tryToCreate
    }
  }, [_vm._v("Create")])])])])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v("Schools")]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [(_vm.schools === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : (!_vm.schools.length) ? _c('div', {
    staticClass: "container"
  }, [_c('i', [_vm._v("No school exists yet")])]) : _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.schools), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _c('td', [_vm._v(_vm._s(_vm._f("count")(item.teachers)))]), _c('td', [_vm._v(_vm._s(_vm._f("count")(item.students)))])])
  }))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _c('th', [_vm._v("Teachers")]), _c('th', [_vm._v("Students")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7112b42e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/Schools.vue
// module id = 436
// module chunks = 0